export const buildTime = '2026-10-10 08:25:24 UTC';
